import { ActionType } from '../infrastructure/actionTypes';
import { IOrder } from '../infrastructure/interfaces';

export default (list: IOrder[] = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_ADMIN_ORDERS_LIST_DONE:
      return [...action.orders];
    case ActionType.CREATE_ORDER_DONE:
      list = list.concat(action.order)
      return list;
    case ActionType.CHANGE_ORDER_STATUS_DONE:
      const { order } = action;
      return list.map(o => o.id === order.id ? order : o);
    case ActionType.DELETE_ORDER:
      return list.filter(o => o.id !== action.id);
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/adminOrdersList.ts